import React from 'react';
import './App.css';
import tlds from './tlds';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state ={
      keyword: '',
      matches: []
    };
  }
  
  handleInput = (e) => {
    this.setState({keyword: e.target.value});
    this.matchWords(e.target.value);
  };

  matchWords = (target) => {
    this.matcher(target.toLowerCase(), tlds)
  }

  /**
  * @param target target word to search for
  * @param list list to search
  * 
  * Description: given a target word, return all words from the list
  * that either start with or end with the target word
  */
  matcher(target, list) {
    const matches = [];
    for (let i = target.length; i >= 0; i--) {
      const targetSubstring = target.substring(i,target.length);
      list.map(word => word.toLowerCase()).forEach( word => {
        if (word === targetSubstring) {
          matches.push(word)
          console.log(word)
        }
      })
    }
    this.setState({matches: matches});
  }

  formattedTlds = () => {
    return this.state.matches.map( tld => {
      const parts = this.state.keyword.split(tld)
      if (parts.length > 0) {
        return `${parts[0]}.${tld}`
      }
    })
  }

  render() {
    return (
      <div className="app">
        <form autoComplete="off" onSubmit={e => { e.preventDefault() }}>
          <input value={this.state.keyword} onChange={this.handleInput} type="text" name="name" className="question" id="name" />
          <label><span>Enter keyword</span></label>
        </form>
        <div>
          {this.formattedTlds().map(tld => {
            return <h1 key={tld}>{tld}</h1>
          })}
        </div>
      </div>
    );
  }
}



export default App;
